// *******************************************************************************
// 1.0 - Mobile menu toggle
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
};

attachEvent('.hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// *******************************************************************************
// 2.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 200);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
    toggleSecondaryNav(false);
  },
  false,
);

// *******************************************************************************
// Add/Remove class when page at top/bottom
// *******************************************************************************
const siteHeader = document.querySelector('.site-header');
const siteFooter = document.querySelector('.footer');

// Function to add the class when at the top
const addClassAtTop = () => {
  document.body.classList.toggle('page-at-top', window.scrollY === 0);
};

// Function to add the class when at the bottom
const addClassAtBottom = () => {
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  document.body.classList.toggle('page-at-bottom', window.scrollY + windowHeight >= documentHeight);
};

if (siteHeader || siteFooter) {
  addClassAtTop();
  addClassAtBottom();

  // Attach event listeners to the window
  window.addEventListener('scroll', addClassAtTop);
  window.addEventListener('scroll', addClassAtBottom);
}

// **************************************************
// Add content ID to first element after breadcrumbs
// **************************************************

window.addEventListener('DOMContentLoaded', () => {
  const mainDiv = document.querySelector('main');
  if (mainDiv) {
    const item = document.querySelector('main > *:first-of-type');
    const heroModule = mainDiv.querySelector('.sc-hero-module');

    if (item === heroModule) {
      item.nextElementSibling.setAttribute('id', 'content');
      item.nextElementSibling.setAttribute('tabIndex', '1');
    } else {
      item.setAttribute('id', 'content');
      item.setAttribute('tabIndex', '1');
    }
  }

  const siteHeader = document.querySelector('.header-main');
  const wcagBtn = document.querySelector('#pojo-a11y-toolbar');
  if (siteHeader) {
    setTimeout(() => {
      document.body.append(siteHeader);
    }, 100);
  }
  if (wcagBtn) {
    setTimeout(() => {
      document.body.append(wcagBtn);
    }, 200);
  }
});
